import React from 'react';
import './Event_about.css';
import close from '../../img/close.svg'

const FAQ = (props) => {
    const state = {
        About_item: [
            {
                text: `Make codebases secure with OWASP`,
            },
            {
                text: `Building a Mobile Design System`,
            },
            {
                text: `How to develop android applications and services that work together in a custom Android OS device`,
            },
            {
                text: `React to UI events in a non-reactive way`,
            },
            {
                text: `Developing a Gradle plugin to automate the translations download`,
            },
            {
                text: `.NET Android (Xamarin. Android) under the hood`,
            },
            {
                text: `Compose in 6 weeks`,
            },
            {
                text: `MVVM Loves Clean Architecture`,
            },
            {
                text: `Growing pains: the challenges of building a scalable application and some strategies to help in the process`,
            },
            {
                text: `How AI is powering the recipe analysis in Chefs' mobile app?`,
            },
            {
                text: `Cyber Security Risk Management, Governance and Control for Android`,
            },
            {
                text: `Process and What Next’s in Payment gateway integration with Android Apps`,
            },
            {
                text: `The Adventure of Kotlin and Compose Through The Multiplatform World`,
            },
            {
                text: `Jetpack compose from beginning to advance`,
            },
            {
                text: `What's App modularization, and why you should consider modularizing your app`,
            },
            {
                text: `Challenges faced by an Android Developer when building an iOS/Android app through KMM`,
            },
            {
                text: `Animating Your Jetpack Compose Apps`,
            },
      ],
    };

    const renderAboutItem = (item, i) => {
        return (
            <div className='about_item'>
                <p><span className='about_terminal--tag'>&lt;TextView</span> android:text=<span className='about_terminal--link'>"{item.text}"</span><span className='about_terminal--tag'>/&gt;</span></p>
                {/* <p>android:id=<span className='about_terminal--link'>"@+id/firstName"</span></p> */}
                {/* <p>android:text=<span className='about_terminal--link'>"{item.text}"</span><span className='about_terminal--tag'>/&gt;</span></p> */}
                {/* <p>android:layout_width=<span className='about_terminal--link'>"wrap_content"</span></p> */}
                {/* <p>android:layout_height=<span className='about_terminal--link'>"wrap_content"</span><span className='about_terminal--tag'>/&gt;</span></p> */}
            </div>
        );
    };

    return (
        <div className="about_wrap">
            <div className="about container">
                <h3 className="about_title">What is this event about</h3>
                <div className="about_blocks">
                    <div className='about_terminal--header'>
                        <div className='about_terminal--tab'>
                            <p className='about_terminal--title'>StreamActivity Java</p>
                            <img className='about_terminal--img' src={close} alt="" />
                        </div>
                        <div className='about_terminal--tab'>
                            <p className='about_terminal--title'>MainActivity Java</p>
                            <img className='about_terminal--img' src={close} alt="" />
                        </div>
                        <div className='about_terminal--tab about_terminal--tab_active'>
                            <p className='about_terminal--title'>activity_main.xml</p>
                            <img className='about_terminal--img' src={close} alt="" />
                        </div>
                    </div>
                    <div className='about_terminal--body'>
                        <p><span className='about_terminal--tag'>&lt;RelativeLayout</span> xmlns:android=<span className='about_terminal--link'>"http://schemas.android.com/apk/res/android"</span><span className='about_terminal--tag'>&gt;</span></p>
                        {state.About_item.map((item, i) => renderAboutItem(item, i))}
                        <p><span className='about_terminal--tag'>&lt;/RelativeLayout</span><span className='about_terminal--tag'>&gt;</span></p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FAQ;